var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: _vm.handleVisibilityChanged,
          expression: "handleVisibilityChanged"
        }
      ],
      class: _vm.bemBlock,
      attrs: { id: _vm.id }
    },
    [
      _c(
        "div",
        {
          ref: "swiper",
          staticClass: "swiper",
          class: _vm.bemElement("carousel"),
          on: {
            click: function($event) {
              return _vm.handleCarouselImageClick($event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "swiper-wrapper" },
            _vm._l(_vm.items, function(item, index) {
              return _c(
                "div",
                {
                  key: _vm.id + "-carousel-item-" + index,
                  staticClass: "swiper-slide",
                  class: [_vm.bemElement("item"), { active: index === 0 }]
                },
                [
                  _vm.shouldRender(index)
                    ? _vm._t(
                        "default",
                        [
                          _c("BaseImage", {
                            class: _vm.bemElement("pic"),
                            attrs: {
                              image: item,
                              "image-classes": _vm.bemElement("image"),
                              loading: "eager"
                            },
                            on: {
                              "image-click": function($event) {
                                return _vm.$emit("image-click", $event)
                              }
                            }
                          })
                        ],
                        {
                          item: item,
                          classname: _vm.bemElement("pic"),
                          index: index,
                          loading: "eager"
                        }
                      )
                    : _vm._e()
                ],
                2
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.shouldShowControls,
              expression: "shouldShowControls"
            }
          ],
          class: _vm.bemElement("control", "prev"),
          attrs: { slot: "button-prev" },
          on: {
            click: function($event) {
              return _vm.goPrevious()
            }
          },
          slot: "button-prev"
        },
        [
          _c("span", {
            staticClass: "icon-arrow-photos icon-arrow-photos--prev",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "sr-only" }, [_vm._v("Previous")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.shouldShowControls,
              expression: "shouldShowControls"
            }
          ],
          class: _vm.bemElement("control", "next"),
          attrs: { slot: "button-next" },
          on: {
            click: function($event) {
              return _vm.goNext()
            }
          },
          slot: "button-next"
        },
        [
          _c("span", {
            staticClass: "icon-arrow-photos icon-arrow-photos--next",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "sr-only" }, [_vm._v("Next")])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }